export const fromAreaInformationTypeApi = (data) => {
  return {
    id: data.id,
    informationType: data.informationType,
    informationTypeEn: data.informationTypeEn,
  };
};
